function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function normalizeTransactionSignature(raw) {
  var value = String(raw || '').trim();
  if (!/^[0-9a-fA-F]{128}$/.test(value)) {
    return '';
  }
  return value.toLowerCase();
}
function describeTransactionLookup(signature, mempoolTx, indexed) {
  if (mempoolTx) {
    return {
      signature: signature,
      status: 'UNCONFIRMED',
      source: 'mempool',
      block_id: '',
      block_hash: '',
      transaction_id: '',
      lc: 0,
      created_at: Number(mempoolTx.timestamp) || 0
    };
  }
  if (indexed) {
    var _indexed$block_id, _indexed$transaction_;
    var onChain = Number(indexed.lc) === 1;
    return {
      signature: signature,
      status: onChain ? 'CONFIRMED' : 'NOT ON LONGEST CHAIN',
      source: 'database',
      block_id: String((_indexed$block_id = indexed.block_id) !== null && _indexed$block_id !== void 0 ? _indexed$block_id : ''),
      block_hash: String(indexed.block_hash || ''),
      transaction_id: String((_indexed$transaction_ = indexed.transaction_id) !== null && _indexed$transaction_ !== void 0 ? _indexed$transaction_ : ''),
      lc: onChain ? 1 : 0,
      created_at: Number(indexed.created_at) || 0
    };
  }
  return {
    signature: signature,
    status: 'NOT FOUND',
    source: '',
    block_id: '',
    block_hash: '',
    transaction_id: '',
    lc: 0,
    created_at: 0
  };
}
function findTransactionInMempool(_x) {
  return _findTransactionInMempool.apply(this, arguments);
}
function _findTransactionInMempool() {
  _findTransactionInMempool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(signature) {
    var loaded, Saito, mempoolTxs, i, txjson;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          loaded = require('saito-js/saito');
          Saito = loaded["default"] || loaded;
          _context.n = 1;
          return Saito.getInstance().getMempoolTxs();
        case 1:
          mempoolTxs = _context.v;
          i = 0;
        case 2:
          if (!(i < mempoolTxs.length)) {
            _context.n = 4;
            break;
          }
          txjson = mempoolTxs[i];
          if (!(String((txjson === null || txjson === void 0 ? void 0 : txjson.signature) || '').toLowerCase() === signature)) {
            _context.n = 3;
            break;
          }
          return _context.a(2, txjson);
        case 3:
          i++;
          _context.n = 2;
          break;
        case 4:
          return _context.a(2, null);
      }
    }, _callee);
  }));
  return _findTransactionInMempool.apply(this, arguments);
}
function lookupTransaction(_x2, _x3) {
  return _lookupTransaction.apply(this, arguments);
}
function _lookupTransaction() {
  _lookupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(mod, signature) {
    var _mod$database, _mod$database$getTran;
    var normalized, mempoolTx, indexed, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          normalized = normalizeTransactionSignature(signature);
          if (normalized) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, null);
        case 1:
          _context2.n = 2;
          return findTransactionInMempool(normalized);
        case 2:
          mempoolTx = _context2.v;
          if (!mempoolTx) {
            _context2.n = 3;
            break;
          }
          _t = null;
          _context2.n = 5;
          break;
        case 3:
          _context2.n = 4;
          return mod === null || mod === void 0 || (_mod$database = mod.database) === null || _mod$database === void 0 || (_mod$database$getTran = _mod$database.getTransactionBySignature) === null || _mod$database$getTran === void 0 ? void 0 : _mod$database$getTran.call(_mod$database, normalized);
        case 4:
          _t = _context2.v;
        case 5:
          indexed = _t;
          return _context2.a(2, describeTransactionLookup(normalized, mempoolTx, indexed || null));
      }
    }, _callee2);
  }));
  return _lookupTransaction.apply(this, arguments);
}
module.exports = {
  describeTransactionLookup: describeTransactionLookup,
  lookupTransaction: lookupTransaction,
  normalizeTransactionSignature: normalizeTransactionSignature
};